import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ec5eb60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderItemInfo_Main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "OrderItemInfo_Title" }, "製品詳細", -1))
const _hoisted_3 = { class: "OrderItemInfo_Table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "書誌CD", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ISBN", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "書誌名", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "本体価格", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "良品/返品", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ISBN13桁", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "取置在庫数", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "在庫ステータス", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "備考", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "カテゴリ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "シリーズ名", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "発売日", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "著者名", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "改装出来", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "重版出来", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "スリップ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "カバー", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ケース", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "帯", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "最新印刷", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "断裁", -1))

import OrderHeader from "../components/OrderHeader.vue";
import OrderFooter from "../components/OrderFooter.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import { Ref, ref } from "vue";
import store from "@/store";
import { OrderSearchDetailData } from "@/types/zaiko";
import { useRoute } from "vue-router";
import { Notyf } from "notyf";
import axios from "axios";

//propsの定義

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderItemInfo',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["toggleGlobalHeader", "showGlobalHeader"],
  setup(__props) {

const props = __props;
//Emitの定義

const route = useRoute();
const notyf = new Notyf();

const isActive_KaniFlg = ref(false);
const isActive_SyosaiFlg = ref(false);
const searchAreaToggle = ref(false);
const fromOrderSearch = ref(false); //orderFooterの表示分岐で使用

//ぱんくずヘッダー
const currentPathList = [
  { name: "受注入力" },
  { name: "通常入力" },
  { name: "製品詳細" },
];

let janCd = route.params.id;
let search_result: Ref<OrderSearchDetailData>;
let orderNum = 1;

const updateNum = (num: number) => {
  orderNum = num;
};
const addOrderToCart = async () => {
  try {
    let cartItem: { janCd: string | null; quantity: number }[] = [];
    let titleMesage = "";

    cartItem.push({
      janCd: String(janCd),
      quantity: orderNum,
    });
    titleMesage = `『${search_result.value.title}』を`;

    if (orderNum === 0) {
      notyf.error("数量を設定してください");
      return;
    }
    const res = await axios.post(
      `${store.getters["getBaseUrl"]}/chumon/cartAddNormalChumon`,
      cartItem,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    console.log(res);
    notyf.success(`${titleMesage}カートに製品を追加しました`);
  } catch (error) {
    console.log(error);
  }
};

// 対象の詳細データをストアから取得する
const getTargetData = () => {
  janCd = route.params.id;
  const res = store.getters["search/getZaikoDataByIsbn"](janCd);
  search_result = ref(res);
  // 著者名の連結
  let authorArray = [] as string[];
  const authorKeyArray = ["author1", "author2", "author3"];
  authorKeyArray.forEach((author) => {
    if (
      search_result.value[author] !== "" &&
      search_result.value[author] !== null
    ) {
      authorArray.push(search_result.value[author]);
    }
  });
  search_result.value.concatenateAuthor =
    authorArray.length !== 0 ? authorArray.join(",") : "";
  console.log(search_result.value);
};
getTargetData();

// 日付のフォーマットを変更する
const formatDate = (date: string | null) => {
  if (typeof date === "string") {
    const targetDate = new Date(date);
    const year = targetDate.getFullYear();
    const month = targetDate.getMonth() + 1;
    const day = targetDate.getDate();
    return year + "/" + month + "/" + day;
  } else {
    return null;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: __props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createVNode(OrderHeader, {
      isActive_KaniFlg: isActive_KaniFlg.value,
      isActive_SyosaiFlg: isActive_SyosaiFlg.value,
      isActive_SidebarFlg: __props.isActive_SidebarFlg,
      searchAreaToggle: searchAreaToggle.value
    }, null, 8, ["isActive_KaniFlg", "isActive_SyosaiFlg", "isActive_SidebarFlg", "searchAreaToggle"]),
    _createElementVNode("div", {
      class: _normalizeClass(["OrderItemInfo", {
      Show_KaniSearch: isActive_KaniFlg.value,
      Show_SyosaiSearch: isActive_SyosaiFlg.value,
      SideBar_False: !__props.isActive_SidebarFlg,
      SideBar_True: __props.isActive_SidebarFlg,
    }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).syosiCd), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).isbn), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).title), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).hontaiPrice?.toLocaleString()), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", null, " 良品: " + _toDisplayString(_unref(search_result).items) + " / 返品: " + _toDisplayString(_unref(search_result).returnItems), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).janCd), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).torioki), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).zsName), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).itemRemarks), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_13,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).category), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_14,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).series), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_15,
            _createElementVNode("td", null, _toDisplayString(formatDate(_unref(search_result).releaseDate)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_16,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).concatenateAuthor), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_17,
            _createElementVNode("td", null, " 予定日:" + _toDisplayString(formatDate(_unref(search_result).kaisoDate)) + " / 予定数:" + _toDisplayString(_unref(search_result).kaisoQuantity), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_18,
            _createElementVNode("td", null, " 予定日:" + _toDisplayString(formatDate(_unref(search_result).juhanDate)) + " / 予定数:" + _toDisplayString(_unref(search_result).juhanQuantity), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_19,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).slip), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_20,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).cover), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_21,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).bookCase), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_22,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).obi), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_23,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).latestPrints), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_24,
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).cutting), 1)
          ])
        ])
      ])
    ], 2),
    _createVNode(OrderFooter, {
      isActive_SidebarFlg: __props.isActive_SidebarFlg,
      fromOrderSearch: fromOrderSearch.value,
      onUpdateNum: updateNum,
      onAddCart: addOrderToCart
    }, null, 8, ["isActive_SidebarFlg", "fromOrderSearch"])
  ], 64))
}
}

})